const shirtSizes = { S: 1, M: 2, L: 3, XL: 4, XXL: 5, "3XL": 6, Unbekannt: 99 };
export default shirtSizes;
export function shirtSizeName(shirtSize) {
  return Object.keys(shirtSizes).find((key) => shirtSizes[key] === shirtSize);
}
